import { Injectable, inject } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Observable, catchError, finalize, throwError } from 'rxjs';
import { API_CONFIG } from 'app/api-config/api-config';
import { IApiConfig } from 'app/interfaces';
import { Router } from '@angular/router';
import { EventsService } from 'app/shared/services/events/events.service';
import { CookiesService } from 'app/shared/services/cookies/cookies.service';
import { UserSessionsService } from 'app/shared/services/user-sessions/user-sessions.service';

@Injectable()
export class DefaultHeaderInterceptor implements HttpInterceptor {
  private apiConfig: IApiConfig = inject(API_CONFIG);
  private router: Router = inject(Router);
  private eventsService: EventsService = inject(EventsService);
  private cookiesService: CookiesService = inject(CookiesService);
  private userSessionsService: UserSessionsService = inject(UserSessionsService);

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.userSessionsService.showProgress();
    if (!req.headers.has('Content-Type') && !req.headers.has('enctype')) {
      req = req.clone({ setHeaders: { 'Content-Type': 'application/json' } });
    }
    if (!req.headers.has('Api-Key')) {
      req = req.clone({ setHeaders: { 'Api-Key': this.apiConfig.apiKey } });
    }
    if (!req.headers.has('Ocp-Apim-Subscription-Key')) {
      req = req.clone({ setHeaders: { 'Ocp-Apim-Subscription-Key': this.apiConfig.subscriptionKey } });
    }
    return next.handle(req).pipe(
      finalize(() => {
        this.userSessionsService.hideProgress();
      }),
      catchError((error) => {
        if (error instanceof HttpErrorResponse) {
          this.eventsService.showMessage({
            severity: 'error',
            summary: 'Status ' + error.status,
            detail: error.error.message,
          });
        }
        if (this.cookiesService.getCookie('queryToken') === '54321' || this.cookiesService.getCookie('queryToken') === '12345') {
          error['offlineMode'] = true;
        }
        if (error.status === 401 || error.status === '401') {
          this.cookiesService.deleteCookie('queryToken');
          this.cookiesService.deleteCookie('userData');
          this.cookiesService.deleteCookie('token');
          this.router.navigate(['login']);
        }
        this.userSessionsService.hideProgress();
        return throwError(() => error);
      }),
    );
  }
}
